import { EvaluationResult } from '../types/energy.types';

interface EnergyResultProps {
  result: EvaluationResult;
  iconCount: number;
}

export const EnergyResult = ({ result, iconCount }: EnergyResultProps) => {
  const levelColors = {
    GREEN: {
      bg: 'bg-success/20',
      border: 'border-success/50',
      text: 'text-success',
    },
    YELLOW: {
      bg: 'bg-warning/20',
      border: 'border-warning/50',
      text: 'text-warning',
    },
    RED: { bg: 'bg-error/20', border: 'border-error/50', text: 'text-error' },
  };

  const colors = levelColors[result.level];

  const levelEmoji = {
    GREEN: '🟢',
    YELLOW: '🟡',
    RED: '🔴',
  };

  const levelDescription = {
    GREEN: 'OK to proceed with standard precautions',
    YELLOW: 'CAUTION - Verify controls before starting',
    RED: 'STOP - Get supervisor approval',
  };

  return (
    <div className="flex flex-col gap-4">
      <div
        className={`inline-flex items-center gap-2 rounded-full border ${colors.border} ${colors.bg} px-4 py-2 font-bold`}
      >
        <span className="text-lg">{levelEmoji[result.level]}</span>
        <span className={colors.text}>{result.level}</span>
        <span className="text-gray-2 text-xs font-semibold">
          {levelDescription[result.level]}
        </span>
      </div>

      <div className="flex gap-3">
        <div className="border-gray-4 bg-mono-1 rounded-xl border px-3 py-2">
          <div className="text-gray-1 text-xl font-extrabold">{iconCount}</div>
          <div className="text-gray-2 text-xs">Icons selected</div>
        </div>
        <div className="border-gray-4 bg-mono-1 rounded-xl border px-3 py-2">
          <div className={`text-xl font-extrabold ${colors.text}`}>
            {result.level}
          </div>
          <div className="text-gray-2 text-xs">Energy rating</div>
        </div>
      </div>

      <div>
        <div className="text-gray-2 mb-2 text-xs font-semibold">
          Triggers (why the rating is what it is)
        </div>
        <ul className="text-gray-1 list-inside list-disc space-y-1 text-sm">
          {result.triggers.map((trigger, idx) => (
            <li key={idx}>{trigger.text}</li>
          ))}
        </ul>
      </div>

      <div>
        <div className="text-gray-2 mb-2 text-xs font-semibold">
          Suggested controls
        </div>
        <ul className="text-gray-1 list-inside list-disc space-y-1 text-sm">
          {result.controls.length > 0 ? (
            result.controls
              .slice(0, 10)
              .map((control, idx) => <li key={idx}>{control}</li>)
          ) : (
            <li>No controls suggested.</li>
          )}
        </ul>
      </div>
    </div>
  );
};
